import { BLOGS_QUERY } from "@/apollo/queries";
import Banner from "@/components/Banner";
import BlogCard from "@/components/Card/BlogCard";
import Loader from "@/components/Loader";
import SEOHead from "@/components/SEO";
import { gql, useQuery } from "@apollo/client";
import { Box, Button, Center, Flex, Container, Grid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import client from "@/apollo-client";
import {
  BANNER_FRAGMENT,
  IMAGE_FRAGMENT,
  SEO_FRAGMENT,
} from "@/apollo/fragments";

const Blog = ({ blogPage }) => {
  const limit = 15; // per page limit
  const [blogsList, setBlogsList] = useState([]);
  const [isHidden, setIsHidden] = useState(false);

  const { loading, error, data, fetchMore } = useQuery(BLOGS_QUERY, {
    variables: {
      blogsQueryPagination: {
        page: 1,
        pageSize: limit,
      },
      notifyOnNetworkStatusChange: true,
    },
  });

  const fetchMoreBlogs = async () => {
    const nextPage = Math.ceil(blogsList.length / limit) + 1;

    await fetchMore({
      variables: {
        blogsQueryPagination: {
          page: nextPage,
          pageSize: limit,
        },
      },
    })
      .then((value) => {
        const pageLimit = value.data.blogs.meta.pagination.pageCount;

        if (nextPage === pageLimit) setIsHidden(true);

        setBlogsList([...blogsList, ...value.data.blogs.data]);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (data && data.blogs.data) {
      if (data.blogs.meta.pagination.pageCount === 1) setIsHidden(true);
      if (blogsList.length === 0) {
        setBlogsList(data.blogs.data);
      } else {
        fetchMoreBlogs();
      }
    }
  }, [data]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return null;
  }

  const { Contact_Us, SEO } = blogPage.attributes;

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Banner data={blogPage.attributes} blogCareerBanner />
      <Box  px={{ base: 5,md: 8, xl:5}}>
        <Box
          as={Container}
          maxW="7xl"
          px={0}
          pt={{ base: 10, md: 10, lg: 14 }}
        >
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              sm: "repeat(1, 1fr)",
              md: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
            }}
            gap={{ base: 8, md: 8 }}
          >
            {blogsList?.map((b, index) => {
              return <BlogCard data={b?.attributes} key={index} />;
            })}
          </Grid>
        </Box>
        <Center pt={16}>
          {!isHidden && (
            <Button onClick={() => fetchMoreBlogs()}>Load more blogs</Button>
          )}
        </Center>
      </Box>
      <Banner data={Contact_Us} classNamechild />
    </>
  );
};

export default Blog;

// seo & blog-page ssr query
export const getServerSideProps = async ({ ctx }) => {
  const { data } = await client.query({
    query: gql`
      query BlogPageQuery {
        blogPage {
          data {
            attributes {
              Contact_Us {
                ...Banner
              }
              Title
              Description
              banner_image {
                ...Image
              }
              SEO {
                ...SEO
              }
            }
          }
        }
      }
      ${BANNER_FRAGMENT}
      ${IMAGE_FRAGMENT}
      ${SEO_FRAGMENT}
    `,
  });

  return {
    props: {
      blogPage: data.blogPage.data ?? [],
    },
  };
};
